<template>
    <div class="mappopup_mosquito boxshadow" v-show="isShowMosqLegend">
        <div class="map_legend_bt_close"><a href="javascript: void(0);" @click.prevent="showMosqLegend()">닫기</a></div>
        <div class="title">모기방역 단계</div>
        <div class="pop_table02">
            <table>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 80%;">
                </colgroup>
                <tbody>
                    <tr>
                        <th class="st01"><p>1단계<br>(쾌적)<br></p></th>
                        <td>
                                <p>야외에 모기 활동이 거의 없음</p>
                                <p>야외에 모기유충 서식지가 형성되지 않음</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="st02"><p>2단계<br>(관심)</p></th>
                        <td>
                                <p>야외에 모기유충 서식지가 20% 이내로 형성된 단계</p>
                                <p>집안으로 침입은 없으나, 외부기온이 낮은 경우 집안으로 침입이 두드러지게 나타남</p>
                                <p>특히 야간에 운동 후, 한 곳에 정지 상태로 10~15분 이상 머물러 있는 경우 간간히 1~2마리의 모기로부터 공격을 받을 수 있음</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="st03"><p>3단계<br>(주의)</p></th>
                        <td>
                                <p>야외에 모기유충 서식지가 20~50% 범위로 형성된 단계</p>
                                <p>단독주택 밀집 지역의 경우, 집안으로 침입하는 모기가 하룻밤에 2~4마리 정도 목격되며, 흡혈 공격도 두드러짐</p>
                                <p>야간 운동 후, 한 곳에 정지 상태로 10~15분 이상 머물러 있는 경우 3-4마리의 모기로부터 공격을 받을 수 있음</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="st04"><p>4단계<br>(불쾌)</p></th>
                        <td>
                            <p>야외에 모기유충 서식지가 50~100% 범위로 형성된 단계</p>
                            <p>단독주택 밀집 지역의 경우, 집안으로 침입하는 모기가 하룻밤에 5~10마리 정도 목격되며, 흡혈 공격이 빈번함</p>
                            <p>야간 운동 후, 한 곳에 정지 상태로 10~15분 이상 머물러 있는 경우 5마리 이상 모기로부터 공격을 받을 수 있음</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_ADM } from '@/confs/common.const';


export default {
    data: function() {
        return {
            isShowMosqLegend: true,
        };
    },
        
    computed: {
    },
    mounted() {
        this.$eventBus.$on('open-medium-mosq-legend', ()=> {
            this.isShowMosqLegend = !this.isShowMosqLegend;
        });
    },
    created() {
    },
    updated: function() {
    },
    methods: {
        showMosqLegend() {
            this.isShowMosqLegend = !this.isShowMosqLegend;
        },
    },
    mixins: [],
}
</script>

<style>
@media (min-width: 2737px) and (max-width: 7680px) {
    .mappopup_mosquito {
        width: 649px;
        height: 722px;
    }
    .mappopup_mosquito .title{
        font-size: 24px;
    }
    .mappopup_mosquito .pop_table02 .st01 p {
        height: 77px;
    }
    .mappopup_mosquito .pop_table02 .st02 p {
        height: 172px;
    }
    .mappopup_mosquito .pop_table02 .st03 p {
        height: 172px;
    }
    .mappopup_mosquito .pop_table02 .st04 p {
        height: 172px;
    }

}
</style>
